<template>
  <RevStickyBar
    class="shadow-long rounded-t-lg mx-auto max-w-full grow border-none px-24 py-24 ease-in-out lg:max-w-[1168px]"
    :visible="products.length > 0"
  >
    <div class="py-12">
      <div class="mb-16 hidden items-center justify-between lg:flex">
        <div class="flex items-center space-x-16">
          <div
            class="bg-static-info-mid rounded-lg flex h-48 w-48 items-center justify-center"
          >
            <IconCompare />
          </div>
          <div>
            <div class="heading-3">{{ i18n(translations.compareDevices) }}</div>
            <div class="text-static-default-low body-2">
              {{ i18n(translations.selectProducts) }}
            </div>
          </div>
        </div>
        <div class="space-x-12">
          <RevButton variant="secondary" @click="emit('clear')">
            {{ i18n(translations.clearAll) }}
          </RevButton>
          <RevButton
            :disabled="products.length < 2"
            variant="primary"
            @click="handleCompareClick"
          >
            {{ i18n(translations.compare) }}
          </RevButton>
        </div>
      </div>
      <ul class="grid grid-cols-2 gap-x-16 lg:grid-cols-4">
        <li
          v-for="(i, index) in 4"
          :key="`comparison-product-${i}`"
          class="hidden items-stretch [&:nth-child(-n+2)]:flex lg:[&:nth-child(-n+4)]:flex"
        >
          <ProductComparisonCard
            v-if="products[index]"
            :image-src="products[index].image"
            :title="products[index].title"
            @remove="emit('remove-product', products[index])"
          />
          <ProductComparisonCardPlaceholder v-else />
        </li>
      </ul>
      <RevButton
        class="mt-16 w-full lg:hidden"
        :class="{ hidden: products.length < 2 }"
        variant="primary"
        @click="handleCompareClick"
      >
        {{ i18n(translations.compare) }}
      </RevButton>
    </div>
  </RevStickyBar>
</template>

<script setup lang="ts">
import { useRoute } from '#imports'

import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { useTracking } from '@backmarket/nuxt-module-tracking/useTracking'
import { RevButton } from '@ds/components/Button'
import { RevStickyBar } from '@ds/components/StickyBar'
import { IconCompare } from '@ds/icons/IconCompare'

import type { ComparisonProduct } from '../../../models/product'

import ProductComparisonCard from './ProductComparisonCard.vue'
import ProductComparisonCardPlaceholder from './ProductComparisonCardPlaceholder.vue'
import translations from './ProductComparisonStickyBar.translations'

const i18n = useI18n()
const route = useRoute()
const { trackClick } = useTracking()

const emit = defineEmits(['clear', 'open-full-modal', 'remove-product'])

defineProps<{
  products: ComparisonProduct[]
}>()

function handleCompareClick() {
  emit('open-full-modal')
  trackClick({
    name: 'compare_cta',
    slugV2: route.params.slugV2,
  })
}
</script>
